<template>
  <div class="text-tip-example">
    <h2>TextTip 组件使用示例</h2>

    <div class="example-item">
      <h3>默认配置（最大20字）</h3>
      <div class="text-container">
        <TextTip>{{ longText }}</TextTip>
      </div>
      <p class="description">
        当文本超过20字时，会显示省略号并在鼠标悬停时显示完整内容的tooltip
      </p>
    </div>

    <div class="example-item">
      <h3>自定义最大字数（10字）</h3>
      <div class="text-container">
        <TextTip :max-length="10">{{ longText }}</TextTip>
      </div>
      <p class="description">
        当文本超过10字时，会显示省略号并在鼠标悬停时显示完整内容的tooltip
      </p>
    </div>

    <div class="example-item">
      <h3>自定义tooltip位置（底部）</h3>
      <div class="text-container">
        <TextTip :placement="'bottom'">{{ longText }}</TextTip>
      </div>
      <p class="description">tooltip 显示在文本底部</p>
    </div>

    <div class="example-item">
      <h3>自定义tooltip主题（浅色）</h3>
      <div class="text-container">
        <TextTip :effect="'light'">{{ longText }}</TextTip>
      </div>
      <p class="description">tooltip 使用浅色主题</p>
    </div>

    <div class="example-item">
      <h3>不显示省略号</h3>
      <div class="text-container">
        <TextTip :show-ellipsis="false">{{ longText }}</TextTip>
      </div>
      <p class="description">
        当文本超过限制时，不会显示省略号，但仍会显示tooltip
      </p>
    </div>

    <div class="example-item">
      <h3>短文本（不显示tooltip）</h3>
      <div class="text-container">
        <TextTip>{{ shortText }}</TextTip>
      </div>
      <p class="description">当文本未超过限制时，不会显示省略号和tooltip</p>
    </div>

    <div class="example-item">
      <h3>包含HTML标签的文本</h3>
      <div class="text-container">
        <TextTip :max-length="15">
          这是一段包含<em style="color: red">强调</em>和<u>下划线</u>的文本内容，当它超过指定的字数限制时，会自动显示省略号并在鼠标悬停时通过tooltip显示完整内容。
        </TextTip>
      </div>
      <p class="description">
        支持包含HTML标签的文本，但tooltip会显示纯文本内容
      </p>
    </div>
  </div>
</template>

<script>
import TextTip from './index.vue'

export default {
  name: 'TextTipExample',
  components: {
    TextTip
  },
  data() {
    return {
      longText:
        '这是一段很长的文本内容，当它超过指定的字数限制时，会自动显示省略号并在鼠标悬停时通过tooltip显示完整内容。',
      shortText: '这是一段短文本。'
    }
  }
}
</script>

<style scoped lang="scss">
.text-tip-example {
  padding: 20px;
  font-family: Arial, sans-serif;
}

h2 {
  margin-bottom: 30px;
  color: #333;
}

.example-item {
  margin-bottom: 30px;
  padding: 20px;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  background-color: #f9f9f9;
}

h3 {
  margin-bottom: 15px;
  color: #666;
  font-size: 16px;
}

.text-container {
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
  border: 1px solid #eaeaea;
  border-radius: 4px;
  width: 300px;
}

.description {
  margin-top: 10px;
  font-size: 14px;
  color: #999;
  line-height: 1.4;
}
</style>
